// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"9e7b1494","264":"1ab2ef49","480":"e81353c1","638":"13985a1c","738":"0cf566f4","740":"a22431e6","778":"642cdb12","854":"49a760df"}[chunkId] + ".chunk.js";
};